import { Input } from '@mantine/core';
import { useController } from 'react-hook-form';
import { AdvancedSwitch } from '@dealstack/frontend/shared/components/Switch/AdvancedSwitch';
import { useTranslationCommonUi } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';

interface Props {
	name: string;
	label: string;
	description?: string | null;
}

export const CustomFieldBooleanInput = ({ name, label, description }: Props) => {
	const tCommonUi = useTranslationCommonUi();
	const { field } = useController({ name });

	const selectedValue = field.value ? field.value === 'true' : undefined;

	const onChange = () => field.onChange(selectedValue ? 'false' : 'true');

	return (
		<Input.Wrapper
			label={label}
			description={description}
			size="lg"
			styles={{
				label: {
					marginBottom: '0.25rem',
				},
			}}
		>
			<AdvancedSwitch
				twoWay
				leftText={tCommonUi('boolean.false')}
				rightText={tCommonUi('boolean.true')}
				leftValue={false}
				rightValue={true}
				selectedValue={selectedValue}
				onChange={onChange}
				size="m"
			/>
		</Input.Wrapper>
	);
};
